<div class="pin-reset-dialog">
  <h2 mat-dialog-title>{{ title }}</h2>

  <p class="pin-reset-subtitle" *ngIf="mode === 'manager' && displayName">
    Issue a new clock-in PIN for <strong>{{ displayName }}</strong>.
    The previous PIN will stop working immediately.
  </p>
  <p class="pin-reset-subtitle" *ngIf="mode === 'self'">
    Confirm your current account password and choose a new 4–8 digit PIN.
  </p>

  <form class="pin-reset-form" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline" *ngIf="mode === 'self'" class="pin-reset-field">
      <mat-label>Current password</mat-label>
      <input matInput type="password" formControlName="currentPassword" autocomplete="current-password">
      <mat-error *ngIf="form.get('currentPassword')?.hasError('required')">
        Password is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="pin-reset-field">
      <mat-label>New PIN</mat-label>
      <input matInput type="password" formControlName="newPin"
             inputmode="numeric" maxlength="8" autocomplete="off">
      <mat-hint>4 to 8 digits.</mat-hint>
      <mat-error *ngIf="form.get('newPin')?.hasError('pattern')">
        PIN must be 4–8 digits.
      </mat-error>
      <mat-error *ngIf="form.get('newPin')?.hasError('required')">
        New PIN is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="pin-reset-field">
      <mat-label>Confirm PIN</mat-label>
      <input matInput type="password" formControlName="confirmPin"
             inputmode="numeric" maxlength="8" autocomplete="off">
      <mat-error *ngIf="form.get('confirmPin')?.hasError('required')">
        Confirm the PIN.
      </mat-error>
    </mat-form-field>

    <div class="pin-reset-error" *ngIf="errorMessage">{{ errorMessage }}</div>

    <div class="pin-reset-actions">
      <button mat-button type="button" (click)="cancel()" [disabled]="loading">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="loading">
        {{ submitLabel }}
      </button>
    </div>
  </form>
</div>
